import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["HighlightCallout","ApprofondimentoCallout","StandardCallout"] */ "/app/src/components/Common/Callout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Common/CardGuideSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Common/Cards/CardFeatured.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Common/Cards/CardFile.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Common/Cards/CardListColumnsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Common/Cards/CardServiceSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Common/ClientComponents/ButtonComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Common/ClientComponents/ButtonSpanImage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Common/DynamicSections/SectionViewAllLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Common/Form/FormRenderer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Common/HorizontalScrollWithControls.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Common/InternalLinkAnchor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Common/ItMediaGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Common/ItStepsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Common/ItVideoBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Common/ItVideoGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Common/RedirectBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Common/Search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Consent/CookiePreferencesLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/DataWisePageComponents/LeafPages/SharedComponents/ItemsAccordionItemClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/DataWisePageComponents/LeafPages/SharedComponents/ItemsAddOns.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/DataWisePageComponents/LeafPages/SharedComponents/ShareBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/DataWisePageComponents/OrganizzazioneTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/DataWisePageComponents/SearchPage/MeilisearchSearchSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/FooterFeedbackSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/HeaderMainNavigationClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/HeaderUserMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MobileNavDrawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SearchDropdownComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SearchModal.tsx");
